import { fromJS } from 'immutable';
import { UPDATE_USER_ATTRIBUTE_ALSO_CACHED_IN_SUPERSTORE, UPDATE_SUPERSTORE_USER_SETTING, UPDATE_SUPERSTORE_PER_CONTENT_SETTING, FETCH_USER_ATTRIBUTES_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
import { enableMapSet } from 'immer';
import { mergeDeep } from 'ContentUtils/helpers/ObjectHelpers';
enableMapSet();
// Moving to a Non-immutable version of the reducer before Immer migration
export const locallyCachedSettingsReducerAsPOJO = (state = {
  perUser: {},
  perContent: {},
  errorLoadingSettings: null
}, {
  type,
  key,
  value,
  parsedAttributes
}) => {
  switch (type) {
    case UPDATE_USER_ATTRIBUTE_ALSO_CACHED_IN_SUPERSTORE:
    case UPDATE_SUPERSTORE_USER_SETTING:
      return Object.assign({}, state, {
        perUser: Object.assign({}, state.perUser, {
          [key]: value
        })
      });
    case UPDATE_SUPERSTORE_PER_CONTENT_SETTING:
      return Object.assign({}, state, {
        perContent: Object.assign({}, state.perContent, {
          [key]: value
        })
      });
    case FETCH_USER_ATTRIBUTES_SUCCEEDED:
      return Object.assign({}, state, {
        perUser: mergeDeep(state.perUser, parsedAttributes)
      });
    default:
      return state;
  }
};
const locallyCachedSettingsReducer = (state = fromJS({
  perUser: {},
  perContent: {},
  errorLoadingSettings: null
}), {
  type,
  key,
  value,
  parsedAttributes
}) => {
  switch (type) {
    case UPDATE_USER_ATTRIBUTE_ALSO_CACHED_IN_SUPERSTORE:
    case UPDATE_SUPERSTORE_USER_SETTING:
      return state.setIn(['perUser', key], value);
    case UPDATE_SUPERSTORE_PER_CONTENT_SETTING:
      return state.setIn(['perContent', key], value);
    case FETCH_USER_ATTRIBUTES_SUCCEEDED:
      return state.mergeDeepIn(['perUser'], fromJS(parsedAttributes));
    default:
      return state;
  }
};
export default locallyCachedSettingsReducer;